//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, computed, onMounted } from '@vue/composition-api'
import {
  mdiAccount, mdiCheck, mdiCheckCircle, mdiHumanMaleChild, mdiQrcodeRemove,
} from '@mdi/js'
import { useRouter, defaultDownloadAppByOS } from '@core/utils'
import usePhone from '@core/utils/usePhone'
import { getKnownMinors, getPublicWaiver, signPublicWaiver } from '@api'
import { i18n } from '@/plugins/i18n'

/**
 * Waiver web por QR (ticket 10, mockup sección 2). Un token por reserva: el
 * jugador elige quién es en el paso 1 (o tipea su nombre si no está en la
 * lista), y en el paso 2 completa nombre, teléfono, email, lee el documento
 * y firma dibujando. Sin OTP: la atribución la dan la cadena de custodia
 * del link (lo emitió un operador para ESTA reserva), los datos tipeados y
 * la firma. Query: `?pm=<player_match_id>` preselecciona (viene del Manager),
 * `?op=<token>` marca la firma como tomada en el mostrador.
 */
export default {
  name: 'WaiverSign',
  setup() {
    // `i18n.t` directo y no el `t` de useUtils: este interpola `{club}` y no
    // usa getCurrentInstance, asi que las reglas de Vuetify (que validan en
    // beforeMount, fuera de setup) pueden llamarlo sin explotar.
    const t = (key, params) => i18n.t(key, params)
    const { route } = useRouter()
    const { phoneCodeOptions } = usePhone()

    const state = ref('loading') // loading | invalid | form | done
    const page = ref(null)
    const step = ref(1)
    const pickedPlayer = ref(null)
    const typedName = ref('')
    const form = ref({
      fullName: '',
      phoneCode: null,
      phone: '',
      email: '',
      marketing: false, // nunca pretildado
    })
    const submitting = ref(false)
    const errorMsg = ref('')
    const pad = ref(null)
    const hasStroke = ref(false)
    const formRef = ref(null)

    // Menores: `guardianOnly` = el adulto no juega, firma sólo por ellos.
    const guardianOnly = ref(false)
    const minors = ref([])
    const knownMinors = ref([])
    const knownSearched = ref(false)
    const knownLoading = ref(false)
    const doneMinors = ref([])
    let minorSeq = 0
    const todayIso = new Date().toISOString().slice(0, 10)
    const NEW_SLOT = 'new'
    const newMinor = () => {
      minorSeq += 1

      return {
        key: minorSeq, fullName: '', birthdate: '', playerMatchId: NEW_SLOT,
      }
    }

    const token = computed(() => route.value.params.token)
    const opToken = computed(() => route.value.query.op || null)

    const rules = {
      required: v => !!(v && String(v).trim()) || t('waiver.required'),
      twoWords: v => (String(v || '').trim().split(/\s+/).length >= 2) || t('waiver.two_words'),
      phone: v => /^[\d\s().-]{6,}$/.test(String(v || '')) || t('waiver.invalid_phone'),
      email: v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '')) || t('waiver.invalid_email'),
      minor: v => {
        const born = new Date(`${v}T12:00:00`)
        if (Number.isNaN(born.getTime()) || v > todayIso) return t('waiver.required')
        const now = new Date()
        let age = now.getFullYear() - born.getFullYear()
        if (now.getMonth() < born.getMonth()
          || (now.getMonth() === born.getMonth() && now.getDate() < born.getDate())) age -= 1

        return age < 18 || t('waiver.minor_too_old')
      },
    }

    const load = async () => {
      let res = null
      try {
        res = await getPublicWaiver(token.value)
      } catch (e) {
        // axiosApi.buildErrorMessage revienta si no hay `response` (red
        // caída, mixed content): sin datos no hay página, se muestra el
        // estado de código inválido en vez de un spinner eterno.
        res = null
      }
      if (!res || res.ok !== 1 || !res.data) {
        state.value = 'invalid'

        return
      }
      page.value = res.data
      // ?pm= del Manager: el operador ya eligió al jugador.
      const pm = Number(route.value.query.pm)
      const pre = pm && res.data.players.find(p => p.player_match_id === pm && !p.signed)
      if (pre) {
        pickedPlayer.value = pre.player_match_id
        form.value.fullName = pre.is_guest ? '' : (pre.display_name || '')
        step.value = 2
      }
      state.value = 'form'
    }

    const canContinue = computed(() => !!pickedPlayer.value || typedName.value.trim().split(/\s+/).length >= 2)

    // Elegir una fila descarta lo tipeado en "no estoy en la lista", y al
    // revés (el @focus del input): una sola identidad a la vez.
    const pickPlayer = p => {
      if (p.signed) return
      pickedPlayer.value = pickedPlayer.value === p.player_match_id ? null : p.player_match_id
      if (pickedPlayer.value) typedName.value = ''
    }
    const initials = name => (name || '')
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(w => w[0])
      .join('')
      .toUpperCase()

    const goToForm = () => {
      if (pickedPlayer.value) {
        const p = page.value.players.find(x => x.player_match_id === pickedPlayer.value)
        if (p && !p.is_guest && p.display_name && !form.value.fullName) form.value.fullName = p.display_name
      } else if (typedName.value.trim()) {
        form.value.fullName = typedName.value.trim()
      }
      step.value = 2
    }

    // Paso 1 → "No juego, firmo como tutor": sin fila propia, con un menor
    // ya abierto para completar.
    const goToGuardian = () => {
      guardianOnly.value = true
      pickedPlayer.value = null
      typedName.value = ''
      if (!minors.value.length) minors.value.push(newMinor())
      step.value = 2
    }
    const backToWho = () => {
      guardianOnly.value = false
      step.value = 1
    }

    // ── Menores ──
    const addMinor = () => {
      minors.value.push(newMinor())
    }
    const removeMinor = i => { minors.value.splice(i, 1) }

    // Filas libres del roster (sin firma) para asignar a un menor; la propia
    // del adulto no se ofrece. "Agregarlo como participante" = fila nueva.
    const slotOptions = computed(() => {
      const free = (page.value ? page.value.players : [])
        .filter(p => !p.signed && p.player_match_id !== pickedPlayer.value)
        .map(p => ({ value: p.player_match_id, text: p.display_name || `${t('waiver.guest')} · ${t('waiver.guest_slot', { n: p.slot })}` }))

      return [{ value: NEW_SLOT, text: t('waiver.minor_slot_new') }, ...free]
    })

    // Una fila no puede ir a dos menores: cada uno ve las libres + la suya.
    const slotOptionsFor = item => {
      const taken = new Set([...minors.value, ...knownMinors.value.filter(k => k.on)]
        .filter(x => x !== item && x.playerMatchId !== NEW_SLOT)
        .map(x => x.playerMatchId))

      return slotOptions.value.filter(o => o.value === NEW_SLOT || !taken.has(o.value))
    }
    const phoneFields = () => {
      const code = phoneCodeOptions.value.find(x => x.value === form.value.phoneCode)
      const digits = String(form.value.phone).replace(/\D/g, '')

      return { code: form.value.phoneCode, number: `+${code ? code.number : ''}${digits}` }
    }
    const canSearchKnown = computed(() => !!form.value.phoneCode
      && rules.phone(form.value.phone) === true && rules.email(form.value.email) === true)
    const findKnownMinors = async () => {
      knownLoading.value = true
      try {
        const ph = phoneFields()
        const fd = new FormData()
        fd.append('phone_code', ph.code)
        fd.append('phone_number', ph.number)
        fd.append('email', form.value.email.trim())
        const res = await getKnownMinors(token.value, fd)
        const list = (res && res.ok === 1 && res.data && res.data.minors) || []
        knownMinors.value = list.map(k => ({ ...k, on: false, playerMatchId: NEW_SLOT }))
      } catch (e) {
        knownMinors.value = []
      } finally {
        knownSearched.value = true
        knownLoading.value = false
      }
    }
    const minorsPayload = () => [
      ...minors.value.map(m => ({
        full_name: m.fullName.trim(),
        birthdate: m.birthdate,
        player_match_id: m.playerMatchId === NEW_SLOT ? null : m.playerMatchId,
      })),
      ...knownMinors.value.filter(k => k.on).map(k => ({
        signature_id: k.signature_id,
        player_match_id: k.playerMatchId === NEW_SLOT ? null : k.playerMatchId,
      })),
    ]

    // El waiver viene renderizado por el backend en el idioma del template:
    // title, body, lang, econsent_label, conspicuous.
    const doc = computed(() => (page.value ? page.value.waiver : {}))

    const paragraphs = computed(() => (doc.value.body || '')
      .split(/\n\s*\n/)
      .map(x => x.trim())
      .filter(Boolean)
      .map(text => ({
        text: doc.value.conspicuous && /negligence/i.test(text) ? text.toUpperCase() : text,
        conspicuous: !!doc.value.conspicuous && /negligence/i.test(text),
      })))

    const reservationLabel = computed(() => {
      if (!page.value) return ''
      const r = page.value.reservation

      return [r.date, r.start_time, r.court].filter(Boolean).join(' · ')
    })
    const publishedLabel = computed(() => (page.value && page.value.waiver.published_at
      ? new Date(page.value.waiver.published_at).toLocaleDateString(doc.value.lang === 'es' ? 'es-AR' : 'en-US')
      : ''))

    // ── Pad de firma: canvas plano, sin librería. Guarda el trazo como PNG. ──
    let ctx = null
    let drawing = false
    const setupPad = () => {
      const c = pad.value
      if (!c) return
      const ratio = window.devicePixelRatio || 1
      const w = c.clientWidth
      const h = c.clientHeight
      c.width = w * ratio
      c.height = h * ratio
      ctx = c.getContext('2d')
      ctx.scale(ratio, ratio)
      ctx.lineWidth = 2.2
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.strokeStyle = '#111'
    }
    const pos = e => {
      const r = pad.value.getBoundingClientRect()

      return { x: e.clientX - r.left, y: e.clientY - r.top }
    }
    const padStart = e => {
      if (!ctx) setupPad()
      drawing = true
      pad.value.setPointerCapture(e.pointerId)
      const p = pos(e)
      ctx.beginPath()
      ctx.moveTo(p.x, p.y)
    }
    const padMove = e => {
      if (!drawing) return
      const p = pos(e)
      ctx.lineTo(p.x, p.y)
      ctx.stroke()
      hasStroke.value = true
    }
    const padEnd = () => { drawing = false }
    const padClear = () => {
      if (!ctx) return
      ctx.clearRect(0, 0, pad.value.width, pad.value.height)
      hasStroke.value = false
    }
    const padBlob = () => new Promise(resolve => pad.value.toBlob(resolve, 'image/png'))

    const submit = async () => {
      errorMsg.value = ''
      if (!formRef.value.validate() || !hasStroke.value) return
      const minorsList = minorsPayload()
      if (guardianOnly.value && !minorsList.length) {
        errorMsg.value = t('waiver.minors_needed')

        return
      }
      submitting.value = true
      try {
        const ph = phoneFields()
        const fd = new FormData()
        fd.append('full_name', form.value.fullName.trim())
        fd.append('phone_code', ph.code)
        fd.append('phone_number', ph.number)
        fd.append('email', form.value.email.trim())
        fd.append('marketing_consent', form.value.marketing ? 'true' : 'false')
        if (pickedPlayer.value) fd.append('player_match_id', String(pickedPlayer.value))
        if (opToken.value) fd.append('op', opToken.value)
        fd.append('sign_self', guardianOnly.value ? 'false' : 'true')
        if (minorsList.length) fd.append('minors', JSON.stringify(minorsList))
        fd.append('signature_png', await padBlob(), 'signature.png')
        const res = await signPublicWaiver(token.value, fd)
        if (res && res.ok === 1) {
          doneMinors.value = ((res.data && res.data.minors) || []).map(m => m.full_name)
          state.value = 'done'
        } else {
          errorMsg.value = (res && res.message) || t('waiver.error_generic')
        }
      } finally {
        submitting.value = false
      }
    }

    const downloadApp = () => defaultDownloadAppByOS()

    onMounted(async () => {
      // Default del selector: el país del club (el jugador está parado ahí).
      await load()
      if (page.value && !form.value.phoneCode) {
        const cc = (page.value.club.country_code || 'US').toUpperCase()
        if (phoneCodeOptions.value.some(x => x.value === cc)) form.value.phoneCode = cc
      }
      // noindex: es una página atada a una reserva, no debe indexarse.
      const meta = document.createElement('meta')
      meta.name = 'robots'
      meta.content = 'noindex, nofollow'
      document.head.appendChild(meta)
    })

    return {
      t,
      state,
      page,
      step,
      pickedPlayer,
      typedName,
      canContinue,
      goToForm,
      form,
      formRef,
      rules,
      phoneCodeOptions,
      doc,
      paragraphs,
      reservationLabel,
      publishedLabel,
      pad,
      hasStroke,
      padStart,
      padMove,
      padEnd,
      padClear,
      pickPlayer,
      initials,
      submit,
      submitting,
      errorMsg,
      downloadApp,
      guardianOnly,
      goToGuardian,
      backToWho,
      minors,
      addMinor,
      removeMinor,
      slotOptions,
      slotOptionsFor,
      knownMinors,
      knownSearched,
      knownLoading,
      canSearchKnown,
      findKnownMinors,
      doneMinors,
      todayIso,
      icons: {
        mdiAccount, mdiCheck, mdiCheckCircle, mdiHumanMaleChild, mdiQrcodeRemove,
      },
    }
  },
}
